module.exports = __webpack_public_path__ + "a05200b3.png";